
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { ChevronRight, Megaphone, Clock, ArrowLeft } from "lucide-react";
import { Channel, Group } from "@/lib/types";

type ChannelHeaderProps = {
  group: Group;
  channel: Channel;
  groupId: string;
  isMobile: boolean;
  expiryTime: string | null;
  onBackClick: () => void;
};

export const ChannelHeader = ({ 
  group,
  channel,
  groupId,
  isMobile,
  expiryTime,
  onBackClick
}: ChannelHeaderProps) => {
  return (
    <>
      <div className="mb-4 flex items-center justify-between">
        <div className="flex items-center space-x-2">
          {isMobile && (
            <Button 
              variant="ghost" 
              size="icon"
              onClick={onBackClick}
            >
              <ArrowLeft className="h-5 w-5" />
            </Button>
          )}
          
          <div>
            <div className="flex items-center">
              <Link 
                to={`/groups/${groupId}`} 
                className="text-muted-foreground hover:text-foreground transition-colors hidden md:inline-block"
              >
                {group.name}
              </Link>
              <ChevronRight className="h-4 w-4 mx-1 text-muted-foreground hidden md:inline-block" />
              <span className="font-medium flex items-center">
                {channel.name}
                {channel.isAnnouncement && <Megaphone className="h-4 w-4 ml-2 text-muted-foreground" />}
                {channel.isTemporary && (
                  <div className="flex items-center ml-2">
                    <Clock className="h-4 w-4 text-orange-500" />
                    {expiryTime && (
                      <span className="text-xs text-orange-500 ml-1">
                        {expiryTime}
                      </span>
                    )}
                  </div>
                )}
              </span>
            </div>
            {channel.description && (
              <p className="text-sm text-muted-foreground">{channel.description}</p>
            )}
          </div>
        </div>
      </div>
      
      <Separator />
    </>
  );
};
